<template>
  <div class="wrapper">
    <h2 class="title2 text-center">{{ title }}</h2>
    <h3 class="caption1 text-center">{{ subtitle }}</h3>
    <div class="carousel-container">
      <CustomCarousel
        :imageUrlList="imageUrlList"
        :cardContentList="cardContentList"
        :selectedCardValue="selectedCardValue"
        @targetIndex="showIndex"
        @selecteditem="selectedItem"
        :storemenu="JSON.parse(JSON.stringify(storeMenu))"
        :selectedGiftCardId="selectedGiftCardId"
      />
    </div>

    <div class="mt-2">
      <form @submit.prevent="pressAddToCart">
        <!-- <div class="form-group">
          <label class="title6">Select Card Value</label>
          <div
            class="d-flex align-center justify-content-between value-container"
            ref="cardValueRef"
          >
            <div
              v-for="(value, index) in cardValues"
              :key="value"
              class="radio-button col-12 col-sm-3 p-0"
            >
              <input
                type="radio"
                class="btn-check"
                name="options-outlined"
                :id="index.toString()"
                autocomplete="off"
                ref="valueInputRef"
                required
              />
             <label
                :class="`btn btn-outline-primary t-style2 ${
                  index === getcurCardValueIndex
                    ? 'radio-active'
                    : ''
                }`"
                :for="index.toString()"
                @click="onValueClick(value, index)"
                >{{ `$${value}.00` }}</label
              >
            </div>
            <div class="radio-button col-12 col-sm-3 p-0">
              <input
                type="radio"
                class="btn-check"
                name="options-outlined"
                id="custom"
                autocomplete="off"
              />
              <label
                @click="onCustomClick"
                :class="`btn btn-outline-primary t-style2 ${
                  [0, 5, 10, 20].every(
                    (num) => form.cardValue !== num && form.cardValue !== ''
                  )
                    ? 'radio-active'
                    : ''
                }`"
                for="custom"
                ref="customRef"
                >Custom</label
              >
            </div>
          </div>
        </div>

        <div v-if="isCustom" class="xs12">
          <label class="title7"
            >Gift Card Amount
            <span :style="{ color: '#FF0000' }">*</span>
          </label>
          <input
            v-model="form.cardValue"
            class="form-control"
            type="number"
            placeholder="Amount from $20 to $500"
            ref="customValueRef"
            min="20"
            max="500"
            @keyup="onCustomInput(form.cardValue)"
            required
          />
        </div> -->

        <div class="form-group">
          <label class="title6">Buy For...</label>
          <div  class="d-flex flex-wrap justify-content-start align-center buyfor-container">
            <div class="col-12 col-md-3 p-0" @click="setFormBuyFor('gift')">
              <input
                type="radio"
                class="btn-check"
                name="buyfor-options-outlined"
                id="buyasgift"
                autocomplete="off"
                required
              />
              <label
                :class="`btn btn-outline-primary t-style2 buyfor-label ${
                  form.buyFor === 'gift' ? 'radio-active' : ''
                }`"
                for="buyasgift"
                @click="isMyself = false"
                >Buy as a Gift</label
              >
            </div>
            <div class="col-12 col-md-3 p-0" @click="setFormBuyFor('self')">
              <input
                type="radio"
                class="btn-check"
                name="buyfor-options-outlined"
                id="buyforself"
                autocomplete="off"
              />
              <label
                :class="`btn btn-outline-primary t-style2 buyfor-label ${
                  form.buyFor === 'self' ? 'radio-active' : ''
                }`"
                for="buyforself"
                @click="isMyself = true"
                >Buy for myself</label
              >
            </div>
          </div>
        </div>

        <div class="form-group">
          <label class="title6">{{
            isMyself ? "Your Details" : "Recipient's Details"
          }}</label>
          <div  class="d-flex justify-content-between align-center details-container">
            <div class="col-12 col-md-6 p-0" :style="{ marginRight: '4px' }">
              <label class="title7"
                >{{ isMyself ? "Your Name" : "Recipient's Name" }}
                <span :style="{ color: '#FF0000' }">*</span>
              </label>
              <input
                v-model="messageModel.To"
                class="form-control"
                type="text"
                required
                pattern=".*\S+.*"
              />
            </div>
            <div class="col-12 col-md-6 p-0">
              <label class="title7"
                >{{ isMyself ? "Your Email" : "Recipient's Email" }}
                <span :style="{ color: '#FF0000' }">*</span></label
              >
              <input
                v-model="messageModel.Email"
                class="form-control"
                type="email"
                required
              />
            </div>
          </div>
        </div>

        <div class="form-group">
          <div class="d-flex justify-content-between align-center" >
            <label class="title6">Gift Message</label>
            <label class="title7">{{ cRemaining }} Characters Remaining</label>
          </div>

          <textarea
            class="form-control"
            id="floatingTextarea2"
            name="textareaRef"
            rows="5"
            maxlength="56"
            ref="textareaRef"
            v-model="messageModel.Message"
            @keyup="textCounter()"
          ></textarea>
        </div>

        <!-- <div class="form-group">
          <label class="title6">Delivery</label>
          <div class="d-flex justify-content-start align-center flex-wrap delivery-container">
            <div class="col-12 col-md-3 p-0" @click="setFormBuyDelivery('now')">
              <input
                type="radio"
                class="btn-check"
                name="delivery-options-outlined"
                id="sendnow"
                autocomplete="off"
                required
              />
              <label
                :class="`btn btn-outline-primary t-style2 buyfor-label ${
                  form.delivery === 'now' ? 'radio-active' : ''
                }`"
                for="sendnow"
                @click="onSendnowClick"
                >Send Now</label
              >
            </div>
            <div class="col-12 col-md-3 p-0" @click="setFormBuyDelivery('schedule')">
              <input
                type="radio"
                class="btn-check"
                name="delivery-options-outlined"
                id="schedule"
                autocomplete="off"
              />
              <label
                :class="`btn btn-outline-primary t-style2 buyfor-label ${
                  form.delivery === 'schedule' ? 'radio-active' : ''
                }`"
                for="schedule"
                @click="onScheduleClick"
                >Schedule Delivery</label
              >
            </div>
          </div>
        </div> -->

        <!-- <div v-show="isSchedule" class="form-group">
          <div class="d-flex justify-content-between align-center flex-wrap" >
            <div class="col-12 col-md-6 p-0">
              <label class="title7">Time Zone</label>
              <select
                class="form-select timezone-picker"
                aria-label="Delivery schedule select"
              >
                <option selected>Select a time zone</option>
                <option
                  v-for="(timezone, index) in gettimezones()"
                  :value="timezone.value"
                  :key="timezone.value+index"
                >
                  {{ timezone.text }}
                </option>
              </select>
            </div>
            <div class="col-12 col-md-6 p-0 date-input">
              <label class="title7">Send Date</label>
              <DatePicker
                v-model="form.sendDate"
                :min-date="new Date()"
                is-required
              >
                <template v-slot="{ inputValue, inputEvents }">
                  <input
                    class="date-picker"
                    :value="inputValue"
                    v-on="inputEvents"
                  />
                </template>
              </DatePicker>
            </div>
            <div class="col-12 col-md-6 p-0">
              <label class="title7">Time</label>
              <input
                class="form-control time-picker"
                type="time"
              />
            </div>
          </div>
        </div> -->

        <button class="purchase-button mt1 title5 py1" type="submit">
          <img
            class="purchase_image"
            src="../../assets/purchase-logo.svg"
            alt="purchase logo"
          />
          Purchase Gift Card
        </button>

       <GiftCardFooter />
      </form>
    </div>
  </div>
</template>

<script lang="ts">
import CustomCarousel from "./CustomCarousel.vue";
import GiftCardFooter from "./GiftCardFooter.vue"
import { timezones } from "../../sharedscripts/timezones";
import store from "../../../src/store";
//import { DatePicker } from "v-calendar";
import { mapMutations, mapActions, mapGetters } from "vuex";
import shared from "../../sharedscripts/giftcard/details";

export default {
  name: "NewGiftCard",
  components: {
    CustomCarousel,
    //DatePicker,
    GiftCardFooter
  },
  props: {
    title: {
      required: true,
      type: String,
    },
    subtitle: {
      required: true,
      type: String,
    },
    imageUrlList: {
      required: true,
      type: Array,
    },
    cardValues: {
      required: true,
      type: Array,
    },
    storeid: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      form: store.getters.buyCardForm,
      isCustom:false,
      isMyself: false,
      isSchedule: false,
      cRemaining: 56,
      cardContentList: store.getters.buyCardForm.cardContentList,
      selectedCardValue: store.getters.selectedCardValue,
      curValueListIndex: store.getters.curValueListIndex,
      curTimeOut:undefined,
      product: null,
      productId: null,
      price: null,
      quantity: 1,
      messageModel: {
        From: "",
        To: "",
        Message: "",
        Email: ""
      },
      selectedGiftCardId: null
    }
  },
  mounted(){
      this.selectedGiftCardId = null
      if (
        [0, 5, 10, 20].every(
          (num) => this.form.cardValue !== num && this.form.cardValue !== ""
        )
      ) {
        this.isCustom = true;
      }

      if (this.form.delivery === "schedule") {
        this.isSchedule = true;
        document.querySelector(".date-picker").setAttribute("required", "false") ;
        document.querySelector(".timezone-picker").setAttribute("required", "false") ;
        document.querySelector(".time-picker").setAttribute("required", "false") ;
      }

      // remove required attribute when there is already value selected
      // if (this.form.cardValue !== "") {
      //   Array.from(document.querySelector(".value-container").children).forEach(
      //     (valuediv) =>
      //       valuediv.children[0].removeAttribute("required")
      //   );
      // }
      if (this.form.buyFor !== "") {
        Array.from(document.querySelector(".buyfor-container").children).forEach(
          (valuediv) =>
            valuediv.children[0].removeAttribute("required")
        );
      }
      // if (this.form.delivery !== "") {
      //   Array.from(document.querySelector(".delivery-container").children).forEach(
      //     (valuediv) =>
      //     valuediv.children[0].removeAttribute("required")
      //   );
      // }

      // this.$refs.valueInputRef[0].removeAttribute("required");
      if(this.giftCartItems.length > 0)
      {
        this.populateProduct()
      }
    },
    methods: {
      ...shared.methods,
      ...mapActions([
        "getStoreMenu",
      ]),
      ...mapMutations([ "setFormBuyDelivery","setFormBuyFor","setcardValue","setbuyFromcardValue","setcurValueListIndex","setCardContent","setCardUrl"]),
      gettimezones(){
        return timezones;
      },
      useDebounce(callback, delay){
        const timeoutRef = setTimeout(() => {
          callback();
        }, delay);
        return timeoutRef;
      },
     textCounter() {
      var field = this.$refs.textareaRef.value;
      if (this.cRemaining > 56) {
        field = field.substring(0, 56);
        return false;
      } else {
        var counter = 56 - field.length;
        this.cRemaining = counter;
      }

      // this.cardContentList.value.forEach((cardContent, index) => {
      //   this.cardContentList.value[index] = this.$refs.textareaRef.value;
      // });
      this.setCardContent = this.$refs.textareaRef.value;
    },
    populateProduct() {
      this.selectedGiftCardId = this.giftCartItems[0].id;
      this.messageModel = this.giftCartItems[0].message;
    },
    pressAddToCart() {
      var store = JSON.parse(JSON.stringify(this.storeMenu));
      if(!this.product){
        let temp = [];
        store.SpecialCategories.SCTypeGiftcard.SubMenuItems.forEach(
          (element) => {
            if (store.Products[element.ProductID]) {
              temp.push(element);
            }
          }
        );

        this.product = temp[0];
      }
      
      this.productId = this.product.ProductID;
      this.price = this.product.Price;
      this.product.ShortDescription = store.Products[this.productId].ShortDescription;
      this.product.PhotoUrl = store.Products[this.productId].PhotoUrl;
      this.product.TaxRate = store.Products[this.productId].TaxRate;
      this.addToCart();
    },
    onSubmit() {
      this.$router.push({name:'giftconfirm'});
    },
    onNameInput(name) {
      store.state.buyCardForm.name = name;
    },
    onEmailInput(email) {
      store.state.buyCardForm.email = email;
    },
    showIndex(index) {
      this.curValueListIndex = index;
      store.state.curValueListIndex = index;
      this.setCardUrl(`card${index + 1}.png`) ;
    },
    selectedItem(item){
      this.product = item;
    },

    onScheduleClick() {
      this.isSchedule = true;
      document.querySelector(".timezone-picker").setAttribute("required", "true");
      document.querySelector(".date-picker").setAttribute("required", "true");
      document.querySelector(".time-picker").setAttribute("required", "true");
    },

    onSendnowClick() {
      this.isSchedule = false;
      document.querySelector(".date-picker").setAttribute("required", "false");
      document.querySelector(".timezone-picker").setAttribute("required", "false");
      document.querySelector(".time-picker").setAttribute("required", "false");
    },

   onValueClick(value, index) {
      this.isCustom = false;

      // set all the card list value to the same click value
      this.selectedCardValue =  value;

      this.setcardValue(value) ;
      this.setbuyFromcardValue(value);
      this.setcurValueListIndex(index);
    },

    onCustomClick() {
      this.isCustom = true;
      this.setcurValueListIndex(3);
      this.setbuyFromcardValue("");
    },

    onCustomInput (customValue) {
      if (this.curTimeOut) {
        clearTimeout(this.curTimeOut);
      }
      if (customValue <= 20 && customValue !== 0) {
        this.curTimeOut = this.useDebounce(() => {
          console.log("time out func < 20 fired: ");
          this.setbuyFromcardValue(20);
          this.selectedCardValue = 20;
        }, 1500);
      } else if (customValue >= 500) {
        this.setbuyFromcardValue(500);
        this.selectedCardValue = 500;
      } else {
        this.cardValueList = customValue || 0;
        this.setbuyFromcardValue(customValue);
      }
    }
  },
  computed: {
    ...mapGetters(["storeMenu","giftCartItems"]),
    getcurCardValueIndex(){
      return store.getters.curValueListIndex;
    },
  },

};
</script>

<style scoped>

.form-group {
  margin-top: 20px;
}
.carousel-container {
  height: 195px;
  max-width: 460px;
  margin: 0 auto;
}
.date-input {
  position: relative;
  height: 62px;
}
.date-input span input {
  height: 38px;
  width: 100%;
}


.button:focus {
  background-color: #55a7ff;
}
.purchase_image {
  width: 7%;
}
.footer_image {
  height: 10px;
  width: 60px;
}
textarea::placeholder {
  font-size: 0.7rem;
  font-weight: 400;
  color: #969da2;
}
.wrapper {
  height: 100%;
  /* min-width: 460px; */
  /* max-width: 460px; */
  /* width: 100%; */
  margin: 0 auto;
}
.value-button {
  width: 100%;
  flex: 1;
  margin: 0 0.5%;
}
.form-control {
  padding-top: 5px;
  padding-bottom: 5px;
}
.purchase-button {
  width: 100%;
  color: #ffffff;
  background-color: #004cd9;
  margin: 2rem 0;
  cursor: pointer;
}
.no-border-button {
  border-radius: 0;
  background-color: #efefef;
}
.underlined {
  text-decoration: underline;
}
.date-caret {
  transform: rotate(180deg);
  position: absolute;
  top: 30px;
  font-size: 26px;
  right: 1%;
  color: black;
}


.time-picker {
  height: 38px;
  font-size: 1rem;
}
.btn {
    display: inline-block;
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    text-align: center;
    text-decoration: none;
    vertical-align: middle;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    background-color: transparent;
    border: 1px solid transparent;
    padding: .375rem .75rem;
    font-size: 1rem;
    border-radius: .25rem;
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}
.btn-check:active+.btn-outline-primary, .btn-check:checked+.btn-outline-primary, .btn-outline-primary.active, .btn-outline-primary.dropdown-toggle.show, .btn-outline-primary:active {
    color: #fff;
    background-color: #0d6efd;
    border-color: #0d6efd;
}
@media only screen and (max-width: 900px) {
  .purchase-button {
    padding: 0.5rem 0;
  }
  .purchase_image {
    width: 7%;
  }
  .details-container {
    flex-wrap: wrap;
  }
}
@media only screen and (max-width: 600px) {
  .radio-button:not(:last-child) {
    margin-right: 0;
    margin-bottom: 10px;
  }
  .value-container {
    flex-wrap: wrap;
  }
  .carousel-container {
    height: 221px;
  }
  .purchase-button {
    margin-top: 2rem;
  }
}
.btn-check {
    position: absolute;
    clip: rect(0,0,0,0);
    pointer-events: none;
}
.buyfor-label {
  width: 100%;
  border-radius: 0;
  border: none;
  background-color: #efefef;
}
.form-select {
    display: block;
    width: 100%;
    padding: .375rem 1.75rem .375rem .75rem;
    font-size: 1rem;
    font-weight: 400;
}
.t-style2 {
    font-size: 14px;
    font-weight: 500;
}
.title7 {
    font-size: 11px;
    font-weight: 400;
    color: #969da2;
}
.title6 {
    font-size: 14px;
    font-weight: 600;
}
.title3 {
    font-size: 20px;
    font-weight: 400;
}
.radio-button:not(:last-child) {
  margin-right: 2px;
}
.radio-button label {
  width: 100%;
  border-color: #d3d8de;
}
.radio-button label:active {
  border: none;
  color: #fff;
}
.radio-active {
  color: #fff;
  background-color: #0d6efd;
  border-color: #0d6efd;
}
</style>
